import { Component } from '@angular/core';
import { DisponibiliteCalendrierComponent } from 'app/service-caisse/disponibilite-calendrier/disponibilite-calendrier.component';

/** Planning de réception : chambres de toutes les formules et espaces, actualisé automatiquement. */
@Component({
  selector: 'app-planning',
  imports: [DisponibiliteCalendrierComponent],
  templateUrl: './planning.component.html',
})
export class PlanningComponent {
  /** Délai d'actualisation automatique, en secondes. */
  readonly actualisation = 60;
}
